module.exports = __webpack_public_path__ + "img/2300_YR_2022_Background.d9dfad7f.png";